export default "__VITE_ASSET__DWx8yKWp__"